<template>
  <div class="contacto">
    <b-row class="m-0">
      <b-col class="col-12 col-md-8 order-2 order-md-1">
        <main-title title="Escribinos" />
        <b-row class="m-0">
          <b-col>
            <b-form-group label="Tipo de consulta" label-for="questtype">
              <b-form-select
                id="questtype"
                :options="[
                  {value: 1, text: 'Ventas editorial'},
                  {value: 2, text: 'Ventas librería'},
                  {value: 3, text: 'Marketing'},
                  {value: 4, text: 'Sugerencias/Reclamos'},
                  {value: 5, text: 'Proveedores'},
                  {value: 6, text: 'Prensa'},
                  {value: 7, text: 'RRHH'},
                  {value: 8, text: 'Derechos de autor'},
                  {value: 9, text: 'Otros'}
                ]"
                v-model="formComments.type"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col>
            <b-form-group label="Mail" label-for="mail">
              <b-form-input id="mail" type="email" trim v-model="formComments.mail"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Teléfono/Celular" label-for="phone">
              <b-form-input id="phone" trim v-model="formComments.phone"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col>
            <b-form-group label="Mensaje" label-for="message">
              <b-form-textarea
                id="message"
                placeholder="Escriba algo..."
                rows="3"
                max-rows="6"
                v-model="formComments.message"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col class="text-right">
            <b-button @click="sendComments()">Enviar</b-button>
          </b-col>
        </b-row>
        <main-title title="El equipo" />
        <div class="d-none d-md-block" v-if="staff !== null">
          <b-row class="mx-0 mb-3">
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">{{staff[1] === undefined ? '' : 'Dirección'}}</div>
              <div style="font-size: small;" v-for="item in staff[1]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[5] === undefined ? '' : 'Departamento de Arte'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[5]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[9] === undefined ? '' : 'Dirección Comercial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[9]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mx-0 mb-3">
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[2] === undefined ? '' : 'Edición'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[2]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[6] === undefined ? '' : 'Prensa y comunicación'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[6]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[10] === undefined ? '' : 'Librería'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[10]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mx-0 mb-3">
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[3] === undefined ? '' : 'Coordinación Editorial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[3]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[7] === undefined ? '' : 'Derechos de autor'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[7]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[11] === undefined ? '' : 'Ventas editorial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[11]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mx-0 mb-3">
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[4] === undefined ? '' : 'Preproducción'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[4]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[8] === undefined ? '' : 'Administración'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[8]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col>
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[12] === undefined ? '' : 'Depósito y logística'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[12]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="d-block d-md-none" v-if="staff !== null">
          <b-row class="mx-0">
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[1] === undefined ? '' : 'Dirección'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[1]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[2] === undefined ? '' : 'Edición'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[2]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[3] === undefined ? '' : 'Coordinación Editorial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[3]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[4] === undefined ? '' : 'Preproducción'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[4]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[5] === undefined ? '' : 'Departamento de Arte'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[5]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[6] === undefined ? '' : 'Prensa y comunicación'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[6]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[7] === undefined ? '' : 'Derechos de autor'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[7]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[8] === undefined ? '' : 'Administración'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[8]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[9] === undefined ? '' : 'Dirección Comercial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[9]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[10] === undefined ? '' : 'Librería'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[10]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[11] === undefined ? '' : 'Ventas editorial'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[11]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
            <b-col class="col-12 mb-3">
              <div style="font-weight: bold; line-height: 1.2em;">
                {{staff[12] === undefined ? '' : 'Depósito y logística'}}
              </div>
              <div style="font-size: small;" v-for="item in staff[12]" :key="item.id">
                {{ item.name }}
                <br />
                {{ item.mail }}
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="col-12 col-md-4 order-1 order-md-2">
        <div
          class="mt-3 p-3 h-100 colContacto"
          style="background: #c8c3c240; border-radius: 1rem; font-size: small; color: #515050;"
        >
          <div style="margin-top: -2rem;">
            <main-title title="Datos de contacto" />
          </div>
          <div id="map1" style="height: 250px"></div>
          <div v-html="contactData"></div>
          <!--
          <div class="mt-4">
            <b-icon icon="geo-alt" class="mr-2" />
            <span>Viamonte 1984 - C.A.B.A. - Argentina</span>
            <br />
            <font-awesome-icon icon="phone-alt" class="mr-2" />
            <span><a href="tel:541143750376">(+54 11) 4375-0376</a></span>
            <br />
            <b-icon icon="envelope-fill" class="mr-2" />
            <span><a href="mailto:libreria@parmenia.com.ar">libreria@parmenia.com.ar</a></span>
          </div>
          <div class="mt-4 py-4 border-top">
            <b>Horarios de atención en librería</b><br/>
            Lunes a viernes de 10 a 16 h.
          </div>
          <div class="py-4 border-top">
            <b>Nuestras redes</b>
            <br />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="facebook-f"
              class="mr-2"
              role="img"
              viewBox="0 0 320 512"
              width="1em"
              height="1em"
            >
              <path
                fill="currentColor"
                d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
              />
            </svg>
            <span><a href="https://www.facebook.com/grupoeditorialparmenia" target="_blank">La Crujía - Editorial y librería</a></span>
            <br />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="twitter"
              class="mr-2"
              role="img"
              viewBox="0 0 512 512"
              width="1em"
              height="1em"
            >
              <path
                fill="currentColor"
                d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
              />
            </svg>
            <span><a href="https://twitter.com/LaCrujiaEd" target="_blank">@LaCrujiaEd</a></span>
            <br />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="instagram"
              class="mr-2"
              role="img"
              viewBox="0 0 448 512"
              width="1em"
              height="1em"
            >
              <path
                fill="currentColor"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              />
            </svg>
            <span><a href="https://www.instagram.com/lacrujiaeditorial/" target="_blank">@lacrujiaeditorial</a></span>
          </div>
          -->
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import axios from "axios";

export default {
  name: "Contacto",
  components: {
    MainTitle
  },
  data() {
    return {
      formComments:{
        type: null,
        mail: '',
        phone: '',
        message: ''
      },
      contactData: null,
      staff: null
    }
  },
  mounted() {
    this.initMap();
    this.loadContactData();
    this.loadStaff();
  },
  methods: {
    // Initialize and add the map
    initMap: function() {
      // The location of Uluru
      const google = window.google;
      var uluru = { lat: -34.601005, lng: -58.395255 };
      // The map, centered at Uluru
      var map = new google.maps.Map(document.getElementById("map1"), {
        zoom: 15,
        center: uluru,
        streetViewControl: false,
        mapTypeControl: false
      });
      // The marker, positioned at Uluru
      var marker = new google.maps.Marker({ position: uluru, map: map });
      return marker;
    },
    async sendComments (){
      if (
        this.formComments.type === null ||
        this.formComments.mail === '' ||
        this.formComments.phone === '' ||
        this.formComments.message === '' 
        ){
          this.$bvModal.msgBoxOk(
            "Por favor completa todos los datos antes de enviar tu consulta",
            {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true
            }
          );
          return;
        }
      await axios
                .post(
                this.$store.state.user.siteData.location + 'clients/contacts/send',
                JSON.stringify(this.formComments),
                {
                    validateStatus(status) {
                    return status < 500 // Resolve only if the status code is less than 500
                    },
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
                )
                .then((evtResponse) => {
                  console.log(evtResponse);
                });
      this.$bvModal.msgBoxOk(
            "Gracias por escribirnos, te responderemos a la brevedad",
            {
              title: "Consulta enviada",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true
            }
          );
    },
    async loadContactData (){
      await axios
        .get('/contactdata.html')
        .then((evtResponse) => {
          this.contactData = evtResponse.data;
        });
    },
    async loadStaff (){
      await axios
        .post(
        this.$store.state.user.siteData.location + 'staff/staff',
        null,
        {
            validateStatus(status) {
            return status < 500 // Resolve only if the status code is less than 500
            },
            headers: {
            'Content-Type': 'application/json',
            },
        }
        )
        .then((evtResponse) => {
          this.staff = []
          evtResponse.data.records.forEach((element) => {
            if (this.staff[parseInt(element.position)] === undefined) {
              this.staff[parseInt(element.position)] = []
            }
            this.staff[parseInt(element.position)][parseInt(element.sort)] = element
          })
        });
    }
  }
};
</script>
